import React, {
    createContext,
    useCallback,
    useContext,
    useEffect,
    useRef,
    useState
  } from 'react'
import { cn } from '../../../utils/classnames'
import CustomButton from '../buttons/CustomButton'
import SecondaryButton from '../buttons/SecondaryButton'

const ConfirmContext = createContext()

export const useConfirm = () => useContext(ConfirmContext)

export const ConfirmProvider = ({ children }) => {
const [options, setOptions] = useState(null)
const [resolver, setResolver] = useState(null)
const modalRef = useRef(null)
const [mouseDownOutside, setMouseDownOutside] = useState(false)
const [visible, setVisible] = useState(false)

const confirm = useCallback((opts) => {
    return new Promise((resolve) => {
    setOptions(opts)
    setResolver(() => resolve)
    setVisible(true)
    })
}, [])

const close = (result) => {
    setVisible(false)
    setTimeout(() => {
    setOptions(null)
    resolver(result)
    }, 200) // tempo igual ao da transição CSS
}

const handleConfirm = () => close(true)
const handleCancel = () => close(false)

const handleMouseDown = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
    setMouseDownOutside(true)
    } else {
    setMouseDownOutside(false)
    }
}

const handleMouseUp = (e) => {
    if (mouseDownOutside && modalRef.current && !modalRef.current.contains(e.target)) {
    handleCancel()
    }
    setMouseDownOutside(false)
}

const handleKeyDown = (e) => {
    if (e.key === 'Escape' && options) {
    handleCancel()
    }
}

useEffect(() => {
    if (options) {
    document.addEventListener('keydown', handleKeyDown)
    } else {
    document.removeEventListener('keydown', handleKeyDown)
    }

    return () => {
    document.removeEventListener('keydown', handleKeyDown)
    }
}, [options])

return (
    <ConfirmContext.Provider value={confirm}>
    {children}
    {options && (
        <div
        className={cn(
            'fixed inset-0 z-50 flex items-center justify-center transition-opacity duration-200',
            visible ? 'opacity-100 bg-black bg-opacity-40' : 'opacity-0 bg-transparent pointer-events-none'
        )}          
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        >
        <div
            ref={modalRef}
            className={cn(
            'bg-white rounded-xl p-6 max-w-md w-full shadow-lg transform transition-all duration-200',
            visible ? 'scale-100 opacity-100' : 'scale-95 opacity-0'
            )}
        >
            <h2 className="text-blueDarker text-lg font-semibold mb-2">
            {options.title || 'Tem certeza?'}
            </h2>
            {options.description && (
            <p className="text-blueDarker mb-4">{options.description}</p>
            )}
            <div className="flex justify-between gap-2 mt-4">
                <SecondaryButton className="w-44" type="button" onClick={handleCancel}>
                    CANCELAR
                </SecondaryButton>
                <CustomButton className="w-44" type="button" onClick={handleConfirm}>
                    {options.confirmText || 'CONFIRMAR'}
                </CustomButton>
            </div>
        </div>
        </div>
    )}
    </ConfirmContext.Provider>
)
}
